import * as types from "../actions/actionTypes";

const initialState = {
  categories: [],
  category: null,
};

const blogcategory = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_BLOG_CATEGORY_RESPONSE:
      return { ...state, categories: action.payload };
    case types.GET_BLOG_CATEGORY_BY_ID_RESPONSE:
      return { ...state, categories: action.payload };
    case types.GET_ACTIVE_BLOG_CATEGORY_RESPONSE:
      return { ...state, categories: action.payload };

    case types.CREATE_BLOG_CATEGORY:
      return { ...state, category: null };
    case types.UPDATE_BLOG_CATEGORY:
      return { ...state, category: null };
    case types.DELETE_BLOG_CATEGORY:
      return { ...state, category: null };
    default:
      return state;
  }
};

export default blogcategory;
